module.exports = __webpack_public_path__ + "static/media/ultrasonic.e4ad4f8e.png";